import config from "../config";
import sendData from "../common/sendData";
import { useKeycloak } from "@react-keycloak/web";

const ApiURL = `${config.app.apiBaseUrl}chatbots/v1/Chatmessages/UserFeedbackType`;

function usePatchUserFeedbackType(){
    const { keycloak } = useKeycloak();

    async function patchUserFeedbackType(chatMessageId, userId){
        let bearerToken = keycloak.token;

        let bodyData = {
            chatMessageId: chatMessageId,
            userFeedbackType: 1,
            lastModifiedByUserId: userId
        }

        await sendData(bearerToken, ApiURL, "PATCH", bodyData, false);
    }

    return patchUserFeedbackType;
}

export default usePatchUserFeedbackType;
